import tw, { styled } from 'twin.macro'
import React from 'react'
import PropTypes from 'prop-types'
import { Input, Button } from './Forms'
import { HeadingSecondary, LeadingAltSecondary } from './Typography'
import { getMailcoachUrl, DEFAULT_LIST } from '../config/mailcoach'

const Wrapper = styled('div')`
  ${tw`container mx-auto text-center my-8 px-4 md:px-0`}
`

const FormWrapper = styled('div')`
  ${tw`md:mx-auto md:flex gap-x-4 justify-center max-w-2xl`}

  button {
    ${tw`mt-4 md:mt-0`}
  }
`

const SubscribeTool = ({ title, subtitle, listId }) => {
  return (
    <Wrapper>
      <HeadingSecondary>{title}</HeadingSecondary>
      {subtitle && <LeadingAltSecondary tw="mb-4">{subtitle}</LeadingAltSecondary>}
      <form
        action={getMailcoachUrl(listId)}
        method="post"
        className="w-full"
      >
        <FormWrapper>
          <Input
            type="email"
            name="email"
            placeholder="Your email address"
            required
          />
          <Button type="submit">
            Subscribe
          </Button>
        </FormWrapper>
      </form>
    </Wrapper>
  )
}

SubscribeTool.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  listId: PropTypes.string
}

SubscribeTool.defaultProps = {
  listId: DEFAULT_LIST
}

export default SubscribeTool
